import { Box, BoxProps, Collapse, Flex, Icon, useControllableState } from '@chakra-ui/react';
import { FaChevronUp } from '@react-icons/all-files/fa/FaChevronUp';
import { ReactNode } from 'react';

type CollapsibleCardProps = {
  header: ReactNode;
  isOpen?: boolean;
  defaultIsOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
  children: ReactNode;
} & Omit<BoxProps, 'onToggle'>;

const CollapsibleCard = ({
  header,
  isOpen: isOpenProp,
  defaultIsOpen = false,
  onToggle,
  children,
  ...boxProps
}: CollapsibleCardProps) => {
  const [isOpen, setIsOpen] = useControllableState({
    value: isOpenProp,
    defaultValue: defaultIsOpen,
    onChange: onToggle,
  });

  return (
    <Box overflow="hidden" {...boxProps}>
      <Flex
        as="button"
        type="button"
        w="100%"
        align="center"
        gap="10px"
        px="18px"
        py="14px"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        {header}
        <Icon
          as={FaChevronUp}
          boxSize="12px"
          color="grayMedium"
          ml="auto"
          flex="none"
          transform={isOpen ? undefined : 'rotate(180deg)'}
          transition="transform 0.2s"
        />
      </Flex>
      <Collapse in={isOpen} animateOpacity>
        {children}
      </Collapse>
    </Box>
  );
};

export default CollapsibleCard;
